export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const NOTIFICATION_SET = 'NOTIFICATION_SET';